<template>
  <div class="list__container">
    <div class="features__wrapper">
      <div class="features__list" :style="{left: sliderLeft + 'px'}">
        <div v-for="(feature, i) in features" :key="i" class="feature">
          <img :src="feature.image" alt="">

          <h3>{{feature.title}}</h3>
          <p>{{feature.content}}</p>
        </div>
      </div>
    </div>

    <div class="features__controllers">
      <div class="img" @click="prevSlide">
        <img src="/media/video-locator-lp-template-e/after-quiz/reviews/arrow-left.svg" alt="arrow left">
      </div>
      <div class="img" @click="nextSlide">
        <img src="/media/video-locator-lp-template-e/after-quiz/reviews/arrow-right.svg" alt="arrow right">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeaturesList",

  props: ["confirmed"],

  data() {
    return {
      slidesToShow: 1,
      activeSlide: 0,
      features: [
        {
          image: "/media/video-locator-lp-template-e/after-quiz/features/feature1.svg",
          title: "Heart rate",
          content: "It helps you monitor your heart function and control your physical activity level to maintain a healthy lifestyle",
        },
        {
          image: "/media/video-locator-lp-template-e/after-quiz/features/feature2.svg",
          title: "Blood pressure & oxygen",
          content: "Measurement of blood pressure is necessary to monitor cardiovascular health, prevent cardiovascular disease",
        },
        {
          image: "/media/video-locator-lp-template-e/after-quiz/features/feature3.svg",
          title: "Body temperature",
          content: "Measuring body temperature is necessary to monitor health status and the effectiveness of healthy lifestyle recommendations",
        },
        {
          image: "/media/video-locator-lp-template-e/after-quiz/features/feature4.svg",
          title: "Export data",
          content: "Export your data for your own records, or to share with your doctor",
        },
      ],
      sliderWidth: 331,
      sliderGap: 24,
    };
  },

  created() {
    // this.timer = setInterval(() => this.nextSlide(), 10000);
    window.addEventListener("resize", this.isMobile);
    this.isMobile();
  },

  beforeDestroy() {
    // clearInterval(this.timer);
    window.removeEventListener("resize", this.isMobile);
  },

  computed: {
    sliderLeft() {
      return -(this.activeSlide * (this.sliderWidth + this.sliderGap));
    },
  },

  methods: {
    isMobile() {
      if (window.innerWidth > 700) {
        this.slidesToShow = 3;
      } else {
        this.slidesToShow = 1;
      }
      this.activeSlide = 0;
    },
    nextSlide() {
      // this.resetTimer();
      if (this.activeSlide + this.slidesToShow >= this.features.length) {
        this.activeSlide = 0;
      } else {
        this.activeSlide++;
      }
    },
    prevSlide() {
      // this.resetTimer();
      if (this.activeSlide - 1 < 0) {
        this.activeSlide = this.features.length - this.slidesToShow;
      } else {
        this.activeSlide--;
      }
    },
    resetTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.nextSlide(), 10000);
    },
  },
}
</script>

<style lang="sass" scoped>
$lg: 700px

.list__container
  width: 100%
  position: relative

  .features__wrapper
    position: relative
    min-height: 330px
    width: 100%
    margin-bottom: 32px

    @media screen and (min-width: $lg)
      margin-bottom: 0

  .features__controllers
    display: flex
    justify-content: center
    gap: 16px

    @media screen and (min-width: $lg)
      display: none

    .img
      cursor: pointer
      transition: .3s ease

      &:hover
        opacity: .8

  .features__list
    display: flex
    flex-direction: row
    flex-wrap: nowrap
    position: absolute
    gap: 24px
    left: 0
    top: 0
    transition: .5s ease

    @media screen and (min-width: $lg)
      position: relative
      .feature
        max-width: 242px
        width: 100%

    .feature
      display: flex
      flex-direction: column
      align-items: center
      position: relative
      width: 343px
      min-height: 330px
      border-radius: 16px
      padding: 24px
      background: rgba(237, 251, 245, 1)
      border: 3px solid rgba(255, 255, 255, 1)
      box-shadow: 1px 4px 8px 0px rgba(117, 117, 117, 0.1)
      z-index: 1

      p
        font-size: 1rem
        line-height: 1.5rem
        font-weight: 500
        color: rgba(107, 107, 107, 1)
        text-align: center

      img
        width: 60px
        height: 60px
        margin-bottom: 18px
</style>
